module.exports = __webpack_public_path__ + "img/4.b54b8a26.jpeg";